import { ReactNode } from 'react';
import { Route } from 'react-router-dom';
import { useUpBreakpoints } from '../../providers/BreakpointsProvider';
import { PermissionsContext, usePermissions } from '../../providers/PermissionsProvider';
import { RestrictedAccessMobileView } from '../RestrictedAccessMobileView/RestrictedAccessMobileView';
import { RestrictedAccessView } from '../RestrictedAccessView/RestrictedAccessView';
import { logEvent } from '../../utils/logger';

interface Props {
  children: ReactNode;
  path: string;
  exact: boolean;
  permissions: keyof PermissionsContext | string[];
}
export const PrivateRoute = ({ children, permissions: permissionName, ...rest }: Props) => {
  const permissions = usePermissions();
  const { md } = useUpBreakpoints();

  return (
    <Route
      {...rest}
      render={() => {
        if (Array.isArray(permissionName)) {
          const hasPermission = permissionName.some((name) => permissions[name as keyof PermissionsContext]);
          if (hasPermission) {
            return children;
          }
        }

        if (permissions[permissionName as keyof PermissionsContext]) {
          return children;
        }

        logEvent({ event: 'route_access_denied', path: rest.path, permissions: permissionName });
        return md ? <RestrictedAccessView /> : <RestrictedAccessMobileView path={rest.path} />;
      }}
    />
  );
};
